import styled, { withTheme } from 'styled-components';

const SStrong = styled.strong`
  font-weight: ${props =>  props.theme.font.weight.medium};
`;

export default withTheme(SStrong);
